import { ModuleConfirmModal } from "@client/content/controls/Modals/Confirm";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Modal from "@client/controls/Modal/container";
import { Status } from "@client/types";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import Content from "../Content/container";
import { type MemberHelpdesk } from "../types";

export type MapProps = RootContainerProps & {
  isVisible: boolean;
  title: string;
  status: MemberHelpdesk.Status;
};

export type ActionProps = {
  onClose: () => void;
};

export type Props = ActionProps & MapProps;
export default (props: Props) => {
  const i18n = useI18n();

  const [showConfirmation, setShowConfirmation] = React.useState<boolean>(false);
  const [comment, setComment] = React.useState<string | null>(null);
  const [mediaIds, setMediaIds] = React.useState<string[]>([]);

  return (
    <>
      <Modal
        className="wsc_content_member_helpdesk_detail_modal"
        hasBackdrop
        isAdminColor={false}
        isDraggable={false}
        isInViewport
        isCentered
        isLoading={props.status === Status.Loading}
        isVisible={props.isVisible}
        onClose={() => {
          comment || mediaIds.length ? setShowConfirmation(true) : props.onClose();
        }}
        width="800px"
      >
        <Modal.Header title={props.title} />

        <Modal.Body>
          <Content
            {...getRootContainerProps(props)}
            onChange={(name, value) => {
              if (name === "comment") {
                setComment(value);
              }

              if (name === "mediaIds") {
                setMediaIds(value);
              }
            }}
          />
        </Modal.Body>
      </Modal>
      <ModuleConfirmModal
        {...getRootContainerProps(props)}
        onClose={() => setShowConfirmation(false)}
        onConfirm={() => {
          props.onClose();
          setComment(null);
          setMediaIds([]);
          setShowConfirmation(false);
        }}
        isVisible={showConfirmation}
      >
        <div>{i18n.infoUnsavedChanges}</div>
      </ModuleConfirmModal>
    </>
  );
};
